<template>
  <div class="auth">
    <div class="warning">
      <p>为了保证您能正常使用小程序所有功能，请先进行小程序授权，并按照小程序提审要求操作后提交审核。<a href='#' style="color:#409eff" @click="appletRequire=true">详情</a></p>
    </div>
    <!--  小程序提审要求  -->
    <el-dialog title="小程序提审要求" :visible.sync="appletRequire" width="60%">
      <div style="padding:0 20px;">
        <h4>1.需上架10个左右的商品，且商品有图片、有库存。</h4>
        <h4>2.需最少上架1个门店。</h4>
        <h4>3.需上架商品分类。</h4>
        <h4>4.不能如有烟、测试字样商品和类别。</h4>
        <h4>5.已上架的商品类别跟小程序类目是否匹配。</h4>
        <h4>6.已上架的商品跟小程序类目是否匹配。</h4>
        <div class="tableinfo-title">小程序类目要求</div>
        <table border="1" cellspacing="0" width="80%" class="table-info">
          <thead>
          <tr class="theadline"><td>行业</td><td>一级分类</td><td>二级分类</td><td>所需材料</td></tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) of tableInfo" :key="index">
            <td>{{item.name}}</td>
            <td>{{item.lv1}}</td>
            <td>{{item.lv2}}</td>
            <td>{{item.desc}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </el-dialog>
    <!--  最新版本  -->
    <el-dialog title="最新版本" :visible.sync="versionShow" width="60%">
      <div style="padding:0 20px;">
        <el-table :data="versionData" style="width: 100%" class="version-table">
          <el-table-column prop="user_version" label="版本号" align="center" width="200"></el-table-column>
          <el-table-column prop="user_desc" label="版本描述" align="center"></el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="versionShow=false">取消</el-button>
        <el-button type="primary" @click="submitAudit">提交审核</el-button>
      </div>
    </el-dialog>
    <div v-if="examine" class="currentAuditSteps">
      <div class="versionNum">V{{version}}</div>
      <div class="steps">
        <el-steps :active="auditStepValue" align-center>
          <el-step :key="index" v-for="(item,index) in auditSteps" :title="item.title" :description="item.description"></el-step>
        </el-steps>
        <div style="text-align: center;padding-top: 20px;">
          <el-button type="primary" v-if="hasNewVersion" @click="openVersionShow">新版本提审</el-button>
        </div>
      </div>
      <div class="auditStatusOperate">
        <el-button v-if="String(examine.status)===auditStatus.APPROVED_AUDIT" type="default" @click="release()">发布</el-button>
        <el-button v-if="String(examine.status)===auditStatus.IN_AUDITING" type="default" @click="undoAudit()">撤销审核</el-button>
        <el-button v-if="String(examine.status)===auditStatus.REJECTED_AUDIT" type="primary" @click="submitAudit()">重新提交审核</el-button>
      </div>
    </div>
    <div class="top">
      <!-- <button @click="test()">恢复</button> -->
      <div class="top-left">
        <div class="leftimage"><img :src="authorizationImgUrl">
          <h2>{{authorizationStatusText}}</h2>
        </div>
<!--        <a :href=hrefUrl>测试授权a链接</a>-->
        <div v-if="!isAuthorizationed" style="text-align:center"><el-button @click="impower()">点击授权</el-button></div>
        <div v-else class="authorizationSuccess">
          <div class="appletInfo">
            <div class="infoName"><span>小程序名称:</span><span style="margin-left:6px;color:#008989">{{nickName}}</span></div>
            <div class="infoBrief">
              <span>小程序简介:</span><span class="briefContent">{{signature}}</span><span class="seeMore" @click="seeMoreDetail()">查看更多详情</span>
            </div>
          </div>
          <div class="authorizationAction">
            <el-button @click="impower()" type='danger'>重新授权</el-button>
            <el-button @click="qrCodePreview()" type='primary'>二维码预览</el-button>
<!--            <img style="width:50px;height:50px;border:1px solid red" :src="imgUrlBase64" alt="">-->
            <el-button v-if="!examine||String(examine.status)===auditStatus.UNDO_AUDIT" type='success' @click="submitAudit(0)">提交审核</el-button>
          </div>
        </div>
      </div>
      <div class="top-right">
        <h2>小程序授权</h2>
        <p>为了保证您能正常使用小程序所有功能，请使用已<br/>认证服务号进行小程序授权</p>
        <p>第三方为您提供信息托管</p>
        <p>为商户提供统一的公众管理平台，包括小程序模板<br/>的提交</p>
        <p>还没有小程序?&nbsp;&nbsp;&nbsp;<a
          href='https://mp.weixin.qq.com/cgi-bin/readtemplate?t=register/step1_tmpl&lang=zh_CN' target="_blank"
          style="color:#33cded">立即申请</a></p>
      </div>
    </div>
    <div class="bottom">
      <h2>小程序管理</h2>
      <div class="bottom-box">
        <div>
          <img src="../../../../static/auth1.jpg" alt="">
          <p>微信官方许可</p>
          <p>微信官方推出的小程序授权</p>
        </div>
        <div>
          <img src="../../../../static/auth2.jpg" alt="">
          <p>小程序免繁琐设置</p>
          <p>小程序运营不再需要理解繁琐参数设置</p>
        </div>
        <div>
          <img src="../../../../static/auth3.jpg" alt="">
          <p>安全可靠的授权</p>
          <p>机密数据传输，保证小程序安全</p>
        </div>
      </div>

    </div>

    <!-- 二维码预览弹出窗 -->
    <el-dialog
      title="请用手机微信扫码预览"
      :visible.sync="qrCodePreviewVisible"
      width="24%"
      custom-class="appletUrgentAuditBox"
    >
      <div class="qrCodeBoxBody" style="height:228px;border:1px solid red">
        <!-- <el-button type='primary' @click="addExperiencer()">添加体验者</el-button> -->
        <img :src="imgUrlBase64" alt="暂无二维码">
      </div>
      <div class="qrCodeBoxFooter" style="text-align:right">
        <el-button @click="qrCodePreviewVisible=false" type="default">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 小程序详情弹出窗-->
    <el-dialog
      title="小程序详情"
      :visible.sync="appletDetailsVisible"
      width="32%"
      :show-close='false'
      custom-class="appletDetailsBox"
    >
      <div class="appletDetailsContent" v-if="appletDetailsVisible">
        <div class="appletLogo"><img :src="appletAuthInfo.headImg" alt=""/></div>
        <div class="appletName">{{appletAuthInfo.nickName}}</div>
        <div class="divider"></div>
        <div class="appletMoreInfo">
           <div class="oneInfo">
             <div class="infoLabel">介绍:</div>{{appletAuthInfo.signature}}
           </div>
           <div class="oneInfo">
             <div class="infoLabel">APPID:</div>{{appletAuthInfo.authorizerAppid}}
           </div>
           <div class="oneInfo">
             <div class="infoLabel">原始ID:</div>{{appletAuthInfo.authorizerAppid}}
           </div>
        </div>
      </div>
      <div class="qrCodeBoxFooter" style="text-align:right">
        <el-button @click="appletDetailsVisible=false" type="default">关闭</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import api from '@/config/api';
export default {
  data() {
    return {
      // hrefUrl:'',
      versionData:[{user_desc:'2fefesd',
        user_version:'1.1',}],
      versionShow:false,
      tableInfo:[
        {name:'商超',lv1:'商家自营',lv2:'百货',desc:'《食品经营许可证》',},
        {name:'商超',lv1:'商家自营',lv2:'酒/盐',desc:'《食品经营许可证》(含预包装食品销售)',},
        {name:'商超',lv1:'商家自营',lv2:'保健品',desc:'《国产保健食品批准证书》或 《进口保健食品批准证书》或 《食品经营许可证》（经营项目须包含保健食品销售）',},
        {name:'母婴',lv1:'商家自营',lv2:'玩具/母婴用品(不含食品)',desc:'',},
        {name:'母婴',lv1:'商家自营',lv2:'食品',desc:'《食品经营许可证》',},
        {name:'母婴',lv1:'商家自营',lv2:'保健品',desc:'《国产保健食品批准证书》或 《进口保健食品批准证书》或 《食品经营许可证》（经营项目须包含保健食品销售）',},
        {name:'烘焙',lv1:'商家自营',lv2:'食品',desc:'《食品经营许可证》',},
        {name:'生鲜',lv1:'商家自营',lv2:'初级食用农产品',desc:'《企业营业执照》',},
        {name:'服装',lv1:'商家自营',lv2:'服装/鞋/箱包',desc:'',},
        {name:'美妆',lv1:'商家自营',lv2:'美妆/洗护',desc:'',},
        {name:'代理商自己体验',lv1:'IT科技',lv2:'硬件与设备',desc:'',},
        {name:'代理商自己体验',lv1:'IT科技',lv2:'软件服务提供商',desc:'',},
      ],
      appletRequire:true,
      hasNewVersion:false,
      version:'V2.0.0',
      imgUrlBase64:'',//预览二位码的base64文件
      auditStepValue:1,//默认处于第一步
      auditSteps:[//步骤条信息
        {
          title:'提交申请',
        },{
          title:'审核中',
        },{
          title:'审核通过',
        },{
          title:'发布成功',
        }
      ],
      examine:null,//小程序当前审核状况
      auditStatus:{
        IN_AUDITING:'2',//审核中
        REJECTED_AUDIT:'1',//审核驳回
        UNDO_AUDIT:'3',//撤回审核
        APPROVED_AUDIT:'0',//审核通过
        SUCCESS_ISSUE:'4',//发布成功
      },
      qrCodePreviewVisible:false,
      appletDetailsVisible:false,
      nickName:'',
      signature:'',
      authorizationImgUrl:'../../../../static/wx.png',
      isAuthorizationed:false,
      authorizationStatusText:'小程序未授权',
      appletAuthInfo:{
        headImg:'',
        nickName:'',
        signature:'',
        authorizerAppid:'',
      },//需要的但不需要展示在界面的信息
    }
  },
  created(){
    this.getData()
  },
  methods: {
    openVersionShow(){
      this.versionShow = true
      this.$axios.fetchPost('/api/system/sysAppConfig/get/privacy/setting',{}).then(res=>{//查询用户权限是否配置
        if(res.code === 200){
          if(res.data && (res.data.setting_list.length===0 || !res.data.setting_list)){
            this.$axios.fetchPost('/api/system/sysAppConfig/set/privacy/setting',{}).then(res=>{// 如果没有配置，则去配置权限
              if(res.code === 200){

              }
            })
          }
        }
      })
    },
    test(){
      this.authorizationStatusText='小程序未授权';
      this.isAuthorizationed=false;
      this.authorizationImgUrl='../../../../static/wx.png'
    },
    //去授权
    impower() {
      this.$axios.fetchPost("/api/system/sysAppConfig/create/preauthcode").then((data) => {
        if (200 === data.code) {
          // this.hrefUrl = data.data
          // window.location.href = data.data
          window.open(data.data, '_blank');
        } else {

        }
      });

      this.$alert('是否授权成功，如授权成功则刷新查看', '授权提示', {
        showClose:false,
        cancelButtonText: '取消',
        confirmButtonText: '刷新',
        callback: (action) => {
          console.log('点击了确定',action)
          this.getData();
        }
      });
    },
    //查看小程序详情
    seeMoreDetail(){
      this.appletDetailsVisible=true;
    },
    undoAudit() {
      this.$confirm('小程序正在审核中, 是否撤销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
        });

        let url=api.system.undoAudit;
        this.$axios.fetchPost(url).then((res)=>{
          loading.close();

          if(res.code===200){
            this.$notify({
              type: "success",
              title: '撤销申请操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({
            //   message:'撤销申请成功，请及时刷新关注查看撤销结果！',
            //   type:'success'
            // })
          }else{
            this.$message.error(res.errorMsg)
          }
        })
      }).catch(() => {
        this.$notify({
          type: "info",
          title: '撤销审核操作',
          message: '成功',
          showClose: false,
        });

        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // });
      });
    },
    addExperiencer(){
        this.$prompt('请输入体验者微信号', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: '邮箱格式不正确'
        }).then(({ value }) => {
          this.$message({
            type: 'success',
            message: '你的邮箱是: ' + value
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
    },
    qrCodePreview(){
      // this.qrCodePreviewVisible=true;

      this.$axios.fetchPost('/api/system/sysAppConfig/auth/query').then((res)=>{
        if(res.code===200){
          this.myURL(res.data.experiencePath);

          //console.log('图片转化成了啥',this.imgUrlBase64)
        }else{
          this.$message.error('获取二维码失败！');
        }
      })
    },
    myURL(buffer){
      // let urlBlob=new Blob(buffer);
      // this.imgUrlBase64=URL.createObjectURL(urlBlob);

      // let blob = new Blob([buffer],  {type: 'application/pdf;charset=UTF-8'});

      var blob = new Blob([buffer],{ type:"text/plain"})
      this.imgUrlBase64 = URL.createObjectURL(blob);
    },
    //二进制转化为base64
    _arrayBufferToBase64(buffer) {
      let binary = "";
      let bytes = new Uint8Array(buffer);
      let len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return "data:image/jpeg;base64," + window.btoa(binary);
    },
    // //将流制转化base64
    // blobToDataURI(blob, callback) {
    //   var reader = new FileReader();
    //   reader.readAsDataURL(blob);
    //   reader.onload = function (e) {
    //       callback(e.target.result);
    //   }
    // },
    // 查询是否配置权限
    submitAudit(){
      this.$axios.fetchPost('/api/system/sysAppConfig/get/privacy/setting',{}).then(res=>{//查询用户权限是否配置
        if(res.code === 200){
          if(res.data) {
            // if (res.data.setting_list.length === 0 || !res.data.setting_list) {
            if (res.data.owner_setting && res.data.owner_setting.notice_method) {//配置过权限，直接去提交审核
              this.saveSubmit()
            }else{
              this.$axios.fetchPost('/api/system/sysAppConfig/set/privacy/setting', {}).then(r => {// 如果没有配置，则去配置权限
                if (r.code === 200) {
                  this.saveSubmit()
                }else{
                  this.$message.error('权限配置失败：'+r.code+r.errorMsg)
                }
              })
            }
          }
        }else{
          this.$message.error('查询权限配置失败：'+res.code+res.errorMsg)
        }
      })
    },
    // 提交审核
    saveSubmit(){
      let url=api.system.submitAppletAudit;
      let data={
        urgentState:0//0:普通审核 1：加急审核
      }
      this.$loading({text:'提交中，请稍后。。。'})
      this.$axios.fetchPost(url,data).then((res)=>{
        if(res.code===200){
          this.$notify({
            type: "success",
            title: '提交审核操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({
          //   message:'提交审核成功，请及时关注页面状态！',
          //   type:'success'
          // })
          this.getData();
          this.versionShow = false
        }else{
          this.$notify({
            type: "error",
            title: '提交审核操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.error(res.code+':提交审核失败！'+res.errorMsg);
        }
      }).finally(()=>{
        this.$loading({}).close()
      })
    },
    getData(){
      const loading = this.$loading({
        lock: true,
      });
      this.$axios.fetchPost('/api/system/sysAppConfig/auth/query').then(res=>{
        loading.close();
        console.log(res)
        if(res.code===200){
          this.appletAuthInfo=res.data.appInfo;
          if(res.data && res.data.appInfo && res.data.appInfo.id){
            // 当前小程序授权状况
            this.authorizationStatusText='小程序已授权';
            this.isAuthorizationed=true;
            if(this.appletAuthInfo.headImg){
              this.authorizationImgUrl=this.appletAuthInfo.headImg;
            }
            if(res.data.appInfo.nickName){
              this.nickName=res.data.appInfo.nickName;
            }
            if(res.data.appInfo.signature){
              this.signature=res.data.appInfo.signature;
            }
            // 版本号
            this.version = res.data.examine.version
            // 是否有新版本
            if(res.data.new_version === 1){
              this.hasNewVersion = true
            }
            // 新版本描述
            if(res.data.template){
              this.versionData = []
              this.versionData.push({
                  user_desc:res.data.template.user_desc,
                  user_version:res.data.template.user_version,
              })
            }
            //保存当前审核状态以备页面的动态展示
            this.examine=res.data.examine;
            switch (String(res.data.examine?this.examine.status:'')) {
              case this.auditStatus.REJECTED_AUDIT://审核驳回
                this.auditStepValue=3;
                this.auditSteps=[//步骤条信息
                  {
                    title:'提交审核',
                  },{
                    title:'审核中',
                  },{
                    title:'审核驳回',
                    description:res.data.examine.rejectMsg
                  }
                ]
                break;
              case this.auditStatus.UNDO_AUDIT://撤回审核
                this.auditStepValue=3;
                this.auditSteps=[//步骤条信息
                  {
                    title:'提交审核',
                  },{
                    title:'审核中',
                  },{
                    title:'撤回审核',
                  }
                ]
                break;
              case this.auditStatus.APPROVED_AUDIT://审核通过
                this.auditStepValue=3;
                this.auditSteps=[//步骤条信息
                  {
                    title:'提交审核',
                  },{
                    title:'审核中',
                  },{
                    title:'审核通过',
                  },{
                    title:'发布成功',
                  }
                ]
                break;
              case this.auditStatus.SUCCESS_ISSUE://发布成功
                this.auditStepValue=4;
                this.auditSteps=[//步骤条信息
                  {
                    title:'提交审核',
                  },{
                    title:'审核中',
                  },{
                    title:'审核通过',
                  },{
                    title:'发布成功',
                  }
                ]
                break;
              default://审核中
                this.auditStepValue=2;
                this.auditSteps=[//步骤条信息
                  {
                    title:'提交审核',
                  },{
                    title:'审核中',
                  },{
                    title:'审核通过',
                  },{
                    title:'发布成功',
                  }
                ]
                break;
            }
          }else{
            this.authorizationStatusText='小程序未授权';
            this.isAuthorizationed=false;
            this.authorizationImgUrl='../../../../static/wx.png'
          }
        }else{
          this.$message.error('查询小程序授权情况失败！');
        }
      })
    },
    release(){
      this.$axios.fetchPost(api.system.appletRelease,{}).then(res=>{
        if(res.code===200){
          this.$notify({
            type: "success",
            title: '发布操作',
            message: '成功',
            showClose: false,
          });
          // this.$message.success('发布成功！');
        }else{
          this.$message.error(res.data.errorMsg || res.data.msg);
        }
      }).catch((err)=>{
        this.$notify({
          type: "error",
          title: '发布操作',
          message: '失败',
          showClose: false,
        });
        // this.$message.error(err.data.errorMsg || '发布错误！');
      })
    }
  }
}
</script>

<style scoped>
.auth {
  width: 100%;
  position: relative;
  padding-top: 1px;
}
.warning{
  margin: 20px;
  padding:5px 10px;
  background-color: #fdf6ec;
  color: #e6a23c;
  border-radius: 4px;
  line-height:24px;
}
.tableinfo-title{
  background-color: #01AAED;
  color:#fff;
  border-radius: 4px;
  width:100px;
  margin: 10px 0;
}
.table-info{
  border-color: #ccc;
}
.table-info .theadline{
  background-color: #f2f2f2;
}
.table-info td{
  width:25%;
  text-align: center;
  height:30px;
  line-height: 30px;
}
>>> .el-table th>.cell{
  padding:10px 0 !important;
}
>>> .el-table td {
  padding:10px 0 !important;
}
.auth .currentAuditSteps{
  width:93%;
  margin:0 auto;
  background-color: #ecf5ff;
  margin-top:50px;
  padding:20px 0px 20px 0px;
}
.auth .currentAuditSteps .versionNum{
  font-size: 20px;
  color:#000;
  text-align: center;
}
.auth .currentAuditSteps .steps{

}
.auth .currentAuditSteps .auditStatusOperate{
  text-align: center;
  margin-top: 10px;
}

.top-left {
  height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid #2ba1fc;
}

.auth .top {
  display: flex;
  height: 320px;
  width: 100%;
  align-items: center;
  justify-content: center;

}

.leftimage {
  margin-right: 40px;
  text-align: center;
  height: 90px;
  line-height: 80px;
  width: 310px;
  box-sizing: border-box;
  border: 3px dashed #2ba1fc;
  margin-bottom: 22px;
}

.leftimage img {
  width: 60px;
  vertical-align: middle;
  margin-right: 15px;
}

.leftimage h2 {
  display: inline;
  color: #2ba1fc;
  font-size: 20px;
  font-weight: 400;
}

.top-right {
  margin-left: 40px;
}

.top-right h2 {
  color: #2ba1fc;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 10px;
}

.top-right p {
  color: #666666;
  line-height: 25px;
}

.auth .bottom {
  border: 1px solid #2ba1fc;
  padding: 0 20px;
  width: 93%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
}

.bottom h2 {
  font-weight: 500;
  color: #2ba1fc;
  width: 230px;
  background: rgba(242, 242, 242);
  text-align: center;
  position: absolute;
  left: 50%;
  top: -20px;
  transform: translateX(-50%);
}

.bottom-box {
  justify-content: space-around;
  display: flex;
  width: 100%;
  height: 220px;
  align-items: center;
}

.bottom-box div {
  flex-direction: column;
  align-items: center;
  display: flex;
  width: 240px;
  height: 150px;
}

.bottom-box div img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.bottom-box div p {
  color: #666666;
  line-height: 30px;
}

.bottom-box div p:nth-of-type(1) {
  font-size: 17px;
}

.appletInfo{
  color:#666666;
}
.appletInfo .infoBrief span{
  display: inline-block;
}
.appletInfo .infoBrief .briefContent{
  margin-left:6px;
  margin-left: 6px;
  width: 50%;
  white-space: nowrap;
  vertical-align: bottom;

  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  color:#008989;
}
.appletInfo .infoBrief .seeMore{
  float:right;
  color:#33CDED;
  cursor:pointer;
  margin-right:5px;
}

.authorizationAction{
  margin-top:10px
}

.auth>>>.el-dialog{
  min-width: auto;
}

.qrCodeBoxFooter{
  margin-top:10px;
}
.appletDetailsBox .appletDetailsContent{
  padding:30px 0px 30px 0px;
}
.appletDetailsBox .appletDetailsContent .appletLogo{
  text-align: center;
}
.appletDetailsBox .appletDetailsContent .appletLogo img{
  width: 100px;
  height: 100px;
}
.appletDetailsBox .appletDetailsContent .appletName{
  color:#606266;
  font-size:16px;
  text-align: center;
}
.appletDetailsBox .appletDetailsContent .divider{
  border:1px solid #E6E6E6;
  margin-top:10px;
}
.appletDetailsBox .appletDetailsContent .appletMoreInfo{
}

.appletDetailsBox .appletDetailsContent .appletMoreInfo{

}
.appletDetailsBox .appletDetailsContent .appletMoreInfo .oneInfo{
  margin-top:10px;
  display: flex;
  flex-flow: row nowrap;
}
.appletDetailsBox .appletDetailsContent .appletMoreInfo .oneInfo .infoLabel{
  width:140px;
}


</style>



// WEBPACK FOOTER //
// src/page/system/applet/Auth.vue